"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextBoxQuestionWidget = void 0;
var React = require("react");
var QuestionWidgetBase_1 = require("./QuestionWidgetBase");
var react_text_mask_1 = require("react-text-mask");
var journey_model_1 = require("@athena-portal/journey-model");
var journey_model_2 = require("@athena-portal/journey-model");
var TextBoxQuestionWidget = exports.TextBoxQuestionWidget = /** @class */ (function (_super) {
    __extends(TextBoxQuestionWidget, _super);
    function TextBoxQuestionWidget() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TextBoxQuestionWidget.prototype.renderInputField = function () {
        var props = {
            type: "text",
            className: "form-control ".concat(this.getInputValidationClass()),
            id: this.props.question.name,
            placeholder: this.props.question.placeHolder,
            // fixes values not updating on undefined
            value: this.bindFromField(this.props.question.interactionField) || "",
            onChange: this.handleOnChangeEvent,
            onFocus: this.executeNativeEvent,
            onBlur: this.handleOnBlurEvent,
            onClick: this.executeNativeEvent,
            onDoubleClick: this.executeNativeEvent,
            readOnly: this.isReadOnly()
        };
        if (this.getSetting("autoComplete") !== undefined) {
            props.autoComplete = this.getSetting("autoComplete") ? "on" : "off";
        }
        if (this.getSetting("mask")) {
            var mask = this.getSetting("mask").map(function (char) { return char.type === "regex" ? new RegExp(char.value) : char.value; });
            return React.createElement(react_text_mask_1.default, __assign({ placeholderChar: " ", mask: mask }, props));
        }
        else {
            return React.createElement("input", __assign({}, props));
        }
    };
    TextBoxQuestionWidget = __decorate([
        (0, journey_model_2.settings)([
            { name: "autoComplete", type: journey_model_2.TypeDescriptions.Boolean },
            { name: "readOnlyExpression", type: journey_model_2.TypeDescriptions.Expression },
            { name: "mask", type: journey_model_2.TypeDescriptions.String },
        ]),
        (0, journey_model_1.events)([
            journey_model_1.Event.onClick,
            journey_model_1.Event.onFocus,
            journey_model_1.Event.onBlur,
            journey_model_1.Event.onDoubleClick
        ])
    ], TextBoxQuestionWidget);
    return TextBoxQuestionWidget;
}(QuestionWidgetBase_1.QuestionWidgetBase));
//# sourceMappingURL=TextBoxQuestionWidget.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/@athena-portal/plugin-journey/dist/widgets/input/TextBoxQuestionWidget.js
// module id = 2361
// module chunks = 0